import React from 'react';

const MarketingPane: React.FC = () => {
  return (
    <aside className="bg-background text-foreground grid grid-rows-[auto_1fr_auto] p-10 md:p-14 lg:p-20">
      <img
        src="/landing-logo.svg"
        alt="Landing"
        className="h-12 w-12"
      />

      <div className="self-center flex flex-col gap-6">
        <h1 className="text-3xl sm:text-5xl md:text-6xl font-medium tracking-tight leading-[1.05] max-w-2xl">
          Nobody needs a
          <br />
          website. Everybody
          <br />
          needs{' '}
          <span className="bg-foreground text-background px-2 rounded">
            a landing
          </span>
          .
        </h1>

        <p className="text-lg text-muted-foreground max-w-xl leading-snug">
          Build simple websites in record time and stop paying for features you don&rsquo;t use.
        </p>
      </div>

      <div className="font-mono text-xs text-muted-foreground flex items-center gap-2">
        <span className="inline-block h-1.5 w-1.5 rounded-full bg-foreground animate-pulse" />
        One page · one price · five minutes
      </div>
    </aside>
  );
};

export default MarketingPane;
